import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Firestore } from '@angular/fire/firestore';

import { Platform } from '@ionic/angular';

import { DataService } from './services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  firestore: Firestore = inject(Firestore);
  constructor(
    private platform: Platform,

    private data: DataService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      //this.statusBar.styleDefault();
      //this.splashScreen.hide();
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
      this.data.toggleDarkTheme(prefersDark.matches);
      // Listen for changes to the prefers-color-scheme media query
      prefersDark.addListener((mediaQuery) => this.data.toggleDarkTheme(mediaQuery.matches));
    });
  }
}
